import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router'

import { AcessoApiService } from '../../../acessoApi.service'
import { ExibirMenuService } from '../../shared/exibir-menu.service'
import { DadosAcessoService } from '../../../dadosAcesso.service'
import { CategoriaAtendimentoService } from './categoriaAtendimento.service'
import { NotificationsService } from 'angular2-notifications';
import {AgGridModule} from 'ag-grid-angular/main';
import { BotoesGridCatRender } from './botoesGridCat.component'
import { CategoriaModel } from './categoria.model'
import { error } from 'util';
declare var $: any


@Component({
  selector: 'app-categoria-atendimento',
  templateUrl: './categoria-atendimento.component.html',
  styleUrls: ['./categoria-atendimento.component.css']
})

export class CategoriaAtendimentoComponent implements OnInit {

  public colDef: any
  private frameworkComponents;
  private columnDefs;
  private rowData;
  private context;
  public niveis: any
  public pais: any
  public codCat: string
  public mensagem: any
  public mensagemErro: any
  public rodar: string = ''

    public nivel_cat: number;
    public num_cat: number;
    public descricao_cat: string;
    public ordem_cat: number
    public id_cat: number
    public id_cat_pai: number


public arrayCategoria: any
public CategoriasAtendimentos: CategoriaModel

public CategoriasAtendimentosEditar: any = [{ id_cat: 0, num_cat: 0, descricao_cat: "",ordem_cat: 0,nivel_cat: 0, cat_pai: "" }]

public options = {
  position: ["bottom", "right"],
  timeOut: 5000,
  lastOnBottom: true

}

  constructor(private exibirItens: ExibirMenuService,private notificacao: NotificationsService, public acessoDadosCat: CategoriaAtendimentoService ,private dadosAcesso: DadosAcessoService, private router: Router, public acessoAPI: AcessoApiService) { 
    if(sessionStorage.getItem('cod_loja') === null){

      this.router.navigate(["/"])
    }
    this.exibirItens.setItensVisiveis(true);
   


  this.acessoAPI.getListaNiveis().subscribe(res =>{
    this.niveis = res
  })

  this.acessoAPI.getListaPais().subscribe(res =>{
    
    this.pais = res

  })
 
  this.acessoAPI.getCategoriaAtendimento().subscribe(res =>{
    this.arrayCategoria = res

    this.rowData = this.arrayCategoria

  }, error =>{

  })


  this.columnDefs = [
    {headerName: 'Núm. Categoria', field: 'num_cat' },
    {headerName: 'Descrição', field: 'descricao_cat' },
    {headerName: 'Ordem', field: 'ordem_cat'},
    {headerName: 'Nível', field: 'nivel_cat'},
    {headerName: 'Categoria Pai', field: 'cat_pai'},
    {headerName: '', field: 'id_cat', cellRenderer:"botoesGridCatRender", colId: 'id_cat', width: 100}
];

this.context = { componentParent: this };

this.frameworkComponents = {
  botoesGridCatRender: BotoesGridCatRender,
}
  }

  ngOnInit() {
   
  }

  SalvarNovaCategoria(){

    this.acessoAPI.SalvarNovaCategoria(this.nivel_cat, this.num_cat,
       this.descricao_cat, this.ordem_cat,  this.id_cat_pai).subscribe(data =>{
        this.mensagem = data

        this.notificacao.success(
          'Solicitação enviada!',
          this.mensagem,
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

        this.nivel_cat = 1, 
        this.num_cat = 0,
        this.descricao_cat = '',
        this.ordem_cat = 0, 
        this.id_cat_pai = 1100

        $("#modalAdicionar").modal('hide');

       }, error=>{

        this.notificacao.error(
          'Solicitação não enviada!',
          error._body,
          {
            timeOut: 2000,
            showProgressBar: false,
            pauseOnHover: false,
            clickToClose: false,
            maxLength: 2
          }
        )

       })
  }

  Refresh(){
    this.rodar = "fa-spin"
    this.acessoAPI.getCategoriaAtendimento().subscribe(res =>{
      this.arrayCategoria = res
  
      this.rowData = this.arrayCategoria

      this.rodar = ""
  
    }, error =>{
      
    })

  }
  

  changeNivel(nivel){
    
     this.nivel_cat = parseInt(nivel.value);
  }

  changePai(pai){
    this.id_cat_pai = parseInt(pai.value)
  }

  excluirCodCat(){
    this.acessoDadosCat.excluirCodCat();
    $("#modalExcluir").modal('hide');
    
  }

  // RecuperarDados(){
  //   this.CategoriasAtendimentosEditar = this.acessoDadosCat.recuperarDados();
  //   if(this.CategoriasAtendimentosEditar === undefined){

  //    this.id_cat = 0
  //    this.num_cat = 0
  //    this.descricao_cat = ""
  //    this.ordem_cat = 0
  //    this.nivel_cat = 0
  //    this.id_cat_pai = 0

  //   }else{
  //    this.id_cat = this.CategoriasAtendimentosEditar[0].ID_CATE
  //    this.num_cat = this.CategoriasAtendimentosEditar[0].NUMERO_CATE
  //    this.descricao_cat = this.CategoriasAtendimentosEditar[0].DESCRICAO_CATE
  //    this.ordem_cat = this.CategoriasAtendimentosEditar[0].ORDEM_CATE
  //    this.nivel_cat = this.CategoriasAtendimentosEditar[0].NIVEL_CATE
  //    this.id_cat_pai = this.CategoriasAtendimentosEditar[0].CATEGORIA_PAI_CATE
  //   }
  // }
 
}



// WEBPACK FOOTER //
// ./src/app/pages/administracao/categoria-atendimento/categoria-atendimento.component.ts